import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from '@papan/i18n'
import { AuthLayout } from '../components/AuthLayout'
import { SignUpForm } from '../components/SignUpForm'
import { safeNext } from '../lib/safe-next'

export function SignupPage() {
  const { t } = useTranslation('auth')
  const [searchParams] = useSearchParams()
  const nextParam = searchParams.get('next')

  return (
    <AuthLayout
      footer={
        <span>
          {t('signup.hasAccount')}{' '}
          <Link to={nextParam ? `/login?next=${encodeURIComponent(safeNext(nextParam))}` : '/login'} className="text-blue-400 hover:text-blue-300">
            {t('signup.signIn')}
          </Link>
        </span>
      }
    >
      <SignUpForm
        googleCallbackPath={safeNext(nextParam)}
        nextParam={nextParam}
      />
    </AuthLayout>
  )
}
